var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.632 15.853a1.258 1.258 0 11-1.779 1.779L12 13.778l-3.853 3.854a1.258 1.258 0 11-1.779-1.779L10.222 12 6.368 8.147a1.258 1.258 0 011.779-1.779L12 10.222l3.853-3.854a1.258 1.258 0 011.779 1.779L13.778 12l3.854 3.853z","fill":"currentColor"}));
}

Clear.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Clear;

Clear.default = Clear;
